<template>
  <div
    id="property-owner-edit-view"
    class="data-list-container"
  >
    <vx-card>
      <div
        slot="no-body"
        class="tabs-container px-6 pt-6"
      >
        <vs-tabs class="tab-action-btn-fill-conatiner">

          <!-- البيانات الأساسية -->
          <vs-tab
            :label="$t('MainInfo')"
            icon-pack="feather"
            icon="icon-info"
          >
            <div class="tab-text">
              <MainData
                v-if="ownerLoaded"
                class="mt-4"
                :PropertyOwner="PropertyOwner"
              />
            </div>
          </vs-tab>

          <!-- كشف حساب المالك -->
          <vs-tab
            :label="$t('FinancialStatement')"
            icon-pack="feather"
            icon="icon-dollar-sign"
          >
            <div class="tab-text">

              <PropertyOwnerFinancialStatement
                v-if="ownerLoaded && ownerId > 0"
                class="mt-4"
                :owner-id="ownerId"
                :key="ownerId"
              />

              <div
                v-else
                class="p-6 text-center text-grey"
              >
                {{ $t('Loading') }}
              </div>

            </div>
          </vs-tab>

        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import MainData from "./MainData.vue";

import PropertyOwnerFinancialStatement
  from "./PropertyOwnerFinancialStatement.vue";

import modulePropertyOwners
  from "@/store/PropertyOwners/modulePropertyOwners.js";

export default {
  name: "PropertyOwnerEditView",

  components: {
    MainData,
    PropertyOwnerFinancialStatement
  },

  data() {
    return {
      userInfo: null,
      user_not_found: false,
      isMounted: false,
      ownerLoaded: false,

      PropertyOwner: {}
    };
  },

  computed: {
    ownerId() {
      if (!this.PropertyOwner) {
        return 0;
      }

      return Number(
        this.PropertyOwner.Id ||
        this.PropertyOwner.id ||
        0
      );
    }
  },

  methods: {
    cancel() {
      this.$router.go(-1);
    },

loadPropertyOwner() {
  const ID = Number(this.$route.params.ID);

  if (!ID || ID <= 0) {
    this.user_not_found = true;
    this.ownerLoaded = false;
    return;
  }

  this.$vs.loading();

  this.$store
    .dispatch(
      "PropertyOwnersList/GetItemByID",
      ID
    )
    .then((res) => {
      let owner = null;

      if (res && res.data && res.data.Data) {
        owner = res.data.Data;
      } else if (res && res.data && res.data.data) {
        owner = res.data.data;
      } else if (res && res.Data) {
        owner = res.Data;
      } else if (res && res.data) {
        owner = res.data;
      }

      if (!owner) {
        this.user_not_found = true;
        this.ownerLoaded = false;
        return;
      }

      this.PropertyOwner = owner;
      this.ownerLoaded = true;

      console.log(
        "Loaded PropertyOwner:",
        this.PropertyOwner
      );

      console.log(
        "Resolved ownerId:",
        this.ownerId
      );
    })
    .catch((err) => {
      this.user_not_found = true;
      this.ownerLoaded = false;

      let errorMessage = this.$t("ErrorOccurred");

      if (
        err &&
        err.response &&
        err.response.data
      ) {
        errorMessage =
          err.response.data.message ||
          err.response.data.Message ||
          errorMessage;
      }

      this.$vs.notify({
        title: this.$t("Error"),
        text: errorMessage,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      });
    })
    .finally(() => {
      this.$vs.loading.close();
    });
}
  },

  created() {
    this.userInfo =
      JSON.parse(
        localStorage.getItem("userInfo")
      );

    if (!modulePropertyOwners.isRegistered) {
      this.$store.registerModule(
        "PropertyOwnersList",
        modulePropertyOwners
      );

      modulePropertyOwners.isRegistered = true;
    }

    this.loadPropertyOwner();
  },

  mounted() {
    this.isMounted = true;
  },

  watch: {
    "$route.params.ID"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.ownerLoaded = false;
        this.PropertyOwner = {};
        this.loadPropertyOwner();
      }
    }
  }
};
</script>